var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseSmleft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 612,
    viewBox: "0 0 311 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14368_32154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.5,
    cy: 289,
    rx: 123.5,
    ry: 135,
    fill: "#1EC3F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14368_32154",
    x: -312,
    y: -34,
    width: 623,
    height: 646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 94,
    result: "effect1_foregroundBlur_14368_32154"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseSmleft);
export default __webpack_public_path__ + "static/media/EllipseSmleft.615e825b25745fea2d9fb7b5693cb16e.svg";
export { ForwardRef as ReactComponent };